import {
	FormControl,
	FormControlLabel,
	FormLabel,
	Checkbox,
	FormHelperText,
	FormGroup,
	Skeleton,
	Stack,
	Box,
} from '@mui/material';
import type { FormikProps } from 'formik';

import { useGetTestsQuery } from '../../slices/apis/testApi';
import { type TestProps, Request, type Status } from '../../models';

interface TestsComponentProps {
	formik: FormikProps<{
		supplierId: string;
		tests: TestProps[];
		status: Status;
	}>;
}

const Tests: React.FC<TestsComponentProps> = ({ formik }) => {
	const { data: tests } = useGetTestsQuery();
	const ifTestChecked = Request.ifMarkTestChecked(formik.values.tests);

	const onTestChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const newValue = e.target.checked
			? [
					...formik.values.tests,
					{
						id: e.target.name,
					},
				]
			: formik.values.tests.filter((test) => Number(test.id) !== Number(e.target.name));

		formik.setValues({
			...formik.values,
			// @ts-ignore
			tests: newValue,
			// reset test centre when we change tests
			supplierId: '',
		});
	};

	const ifError = Boolean(formik.touched.tests) && Boolean(formik.errors.tests);

	return (
		<>
			{!tests ? (
				<Stack width={240} spacing={3}>
					<Skeleton variant="rectangular" animation="wave" height={18} />
					<Skeleton variant="rectangular" animation="wave" height={18} />
					<Skeleton variant="rectangular" animation="wave" height={18} />
					<Skeleton variant="rectangular" animation="wave" height={18} />
				</Stack>
			) : (
				<FormControl margin="normal" component="fieldset" variant="standard" error={ifError} sx={{ mt: 0 }}>
					<FormLabel component="legend">Tests</FormLabel>
					{ifError && <FormHelperText>{formik.errors.tests as string}</FormHelperText>}
					<FormGroup>
						{tests.map((test) => (
							<FormControlLabel
								key={test.id}
								control={
									<Checkbox
										name={test.id.toString()}
										checked={ifTestChecked(test)}
										onChange={onTestChange}
										disabled={Request.disableTestsEditing(formik.values.status)}
									/>
								}
								label={
									<Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between', minWidth: 320 }}>
										<span>{test.name}</span>
									</Box>
								}
							/>
						))}
					</FormGroup>
				</FormControl>
			)}
		</>
	);
};

export default Tests;
